<template>
  <div class="overflow-hidden rounded-lg bg-background">
    <slot />
  </div>
</template>
